<template>
    <div class="bg-white py-24 pt-0 sm:py-32">
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl lg:text-center">
          <h2 class="text-base/7 font-semibold text-indigo-600">Expertise</h2>
          <p class="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl lg:text-balance">How can we help?</p>
        </div>
        <div class="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <dl class="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            <div v-for="feature in features" :key="feature.name" class="flex flex-col">
              <dt class="flex items-center gap-x-3 text-base/7 font-semibold text-gray-900">
                {{ feature.name }}
              </dt>
              <dd class="mt-4 flex flex-auto flex-col text-base/7 text-gray-600">
                <p class="flex-auto">{{ feature.description }}</p>
                <img :src="feature.image" alt="" class="mt-4" />
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </template>

  <script setup>

  const features = [
    {
      name: 'Bathrooms',
      description:
        'Elevate your home with a bathroom designed for relaxation and luxury. From elegant tiling and premium fixtures to expertly crafted storage solutions, we create spaces that combine practicality with style. Whether it\'s a complete renovation or a simple refresh, our team ensures every detail is perfect, so you can enjoy a spa-like retreat in the comfort of your home.',
      href: '#',
      image: './images/bathroom.jpeg',
    },
    {
      name: 'Kitchens',
      description:
        'Transform your kitchen into the heart of your home with our expert craftsmanship. Whether you\'re dreaming of a modern, sleek design or a cozy, traditional space, we specialize in bringing your kitchen to life. Let us help you cook, dine, and entertain in style.',
      href: '#',
      image: './images/kitchen.jpeg',
    },
    {
      name: 'Roofing',
      description:
        'Protect your home with our reliable and durable roofing solutions. Whether you need repairs, replacements, or entirely new installations, we have the experience to ensure your roof stands strong against the elements. With years of experience in a variety of roofing materials and techniques, we’ll deliver results that give you peace of mind for years to come.',
      href: '#',
      image: './images/roofing.jpeg',
    },
  ]
  </script>